import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import BlogBoxHome from "../../Component/BlogsCMPT/BlogBoxHome";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import "./BlogCSS.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function Blogs() {
  const { RendomTokenfetch, Pagemetatags } = useAuth();
  const [blogData, setBlogData] = useState([]);
  // console.log(blogData);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [TotalBlogs, setTotalBlogs] = useState(1);

  const limit = 9; // per page blogs

  const FetchBlogData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}blogAPI.php?page=${currentPage}&limit=${limit}`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setBlogData(response.data.blogdata);
            setTotalPages(response.data.totalPages);
            setTotalBlogs(response.data.totalBlogs);
          }
          if (response.data.status === "0") {
            setBlogData([]);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, currentPage]);

  useEffect(() => {
    FetchBlogData();
  }, [FetchBlogData]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  // 🟢 Pagination Buttons
  const renderPagination = () => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <li
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`${currentPage === i ? "current" : ""}`}
        >
          <a href="#;"> {i}</a>
        </li>
      );
    }
    return pages;
  };
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.newstitle}</title>
        <meta name="description" content={Pagemetatags.newsdescription} />
        <meta name="keywords" content={Pagemetatags.newskeyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Blogs" mainpage="" />

      <section className="blog-section section-padding bg_section ">
        <div className="container">
          <div className="row blog-section-grids">
            {loading ? (
              <p className="text-center">Loading blogs...</p>
            ) : blogData.length > 0 ? (
              blogData.map((val) => (
                <BlogBoxHome key={val.id || val._id} blogdata={val} />
              ))
            ) : (
              <p className="text-center">No blogs available right now.</p>
            )}
          </div>

          {TotalBlogs > limit && (
            <div className="row page-pagination-wrapper">
              <div className="col col-xs-12">
                <div className="page-pagination">
                  <ul className="">
                    <li
                      onClick={() =>
                        setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))
                      }
                      disabled={currentPage === 1}
                    >
                      <a href="#;">
                        <i className="fa fa-angle-double-left"></i>
                      </a>
                    </li>
                    {renderPagination()}
                    <li
                      onClick={() =>
                        setCurrentPage((prev) =>
                          prev < totalPages ? prev + 1 : prev
                        )
                      }
                      disabled={currentPage === totalPages}
                    >
                      <a href="#;">
                        <i className="fa fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
